"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DBLogsList = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
require("@front/components/form-parts/date/component");
require("@front/components/form-parts/select/component");
require("@front/components/form-parts/tags/component");
require("@front/components/code-screen/component");
require("@front/components/pagination/component");
const trans_1 = require("../../../../../common/translations/trans");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid dblogs-list-page">
  <div class="row">
    <div class="col-12">
      <div class="mb-3 d-flex align-items-center justify-content-between">
        <h1>${'dblogs.title'.t()}</h1>
        ${(0, fast_element_1.when)(x => x.loading || x.filtersLoading, (0, fast_element_1.html) `<app-loader block="true" width="20" height="20"></app-loader>`)}
      </div>

      
      <div class="card card-body mb-4">
        <div class="row g-3">
          <div class="col-md-2">
            <part-date
              label="${'dblogs.filter.dateFrom'.t()}"
              name="dateFrom"
              :value="${x => x.filters.dateFrom}"
              @change="${(x, c) => x.handleFilterChange('dateFrom', c.event)}"
            ></part-date>
          </div>
          <div class="col-md-2">
            <part-date
              label="${'dblogs.filter.dateTo'.t()}"
              name="dateTo"
              :value="${x => x.filters.dateTo}"
              @change="${(x, c) => x.handleFilterChange('dateTo', c.event)}"
            ></part-date>
          </div>
          <div class="col-md-3">
            <part-tags
              label="${'dblogs.filter.models'.t()}"
              name="models"
              allowNew="false"
              placeholder="${'dblogs.filter.models.placeholder'.t()}"
              :suggestions="${x => x.modelOptions}"
              :value="${x => x.filters.models}"
              @change="${(x, c) => x.handleFilterChange('models', c.event)}"
            ></part-tags>
          </div>
          <div class="col-md-3">
            <part-tags
              label="${'dblogs.filter.operations'.t()}"
              name="operations"
              allowNew="false"
              placeholder="${'dblogs.filter.operations.placeholder'.t()}"
              :suggestions="${x => x.operationOptions}"
              :value="${x => x.filters.operations}"
              @change="${(x, c) => x.handleFilterChange('operations', c.event)}"
            ></part-tags>
          </div>
          <div class="col-md-3">
            <part-tags
              label="${'dblogs.filter.recordIds'.t()}"
              name="recordIds"
              allowNew="true"
              placeholder="${'dblogs.filter.recordIds.placeholder'.t()}"
              :value="${x => x.filters.recordIds}"
              @change="${(x, c) => x.handleFilterChange('recordIds', c.event)}"
            ></part-tags>
          </div>
          <div class="col-md-2">
            <button
              type="button"
              class="btn btn-primary w-100"
              @click="${x => x.search()}"
              ?disabled="${x => x.loading}"
            >${'dblogs.filter.search'.t()}</button>
          </div>
        </div>
      </div>

      
      <div class="mb-2 text-muted small">
        ${'dblogs.results.total'.t()}: <strong>${x => x.count}</strong>
      </div>

      
      <div class="card">
        <div class="table-responsive">
          <table class="table table-hover mb-0 dblogs-table">
            <thead>
              <tr>
                <th>#</th>
                <th>${'dblogs.col.model'.t()}</th>
                <th>${'dblogs.col.operation'.t()}</th>
                <th>${'dblogs.col.recordId'.t()}</th>
                <th>${'dblogs.col.date'.t()}</th>
                <th>${'dblogs.col.payload'.t()}</th>
                <th>${'dblogs.col.result'.t()}</th>
              </tr>
            </thead>
            <tbody>
              ${(0, fast_element_1.when)(x => !x.loading && x.logs.length === 0, (0, fast_element_1.html) `
                <tr>
                  <td colspan="7" class="text-center text-muted py-4">${'dblogs.empty'.t()}</td>
                </tr>
              `)}
              ${(0, fast_element_1.repeat)(x => x.logs, (0, fast_element_1.html) `
                <tr>
                  <td class="text-muted">${x => x.id}</td>
                  <td>
                    <span class="badge bg-primary">${x => x.modelLabel}</span>
                  </td>
                  <td>
                    <span class="badge dblogs-op-badge dblogs-op-${x => x.operation}">${x => x.operationLabel}</span>
                  </td>
                  <td class="font-monospace">${x => { var _a; return (_a = x.recordId) !== null && _a !== void 0 ? _a : '—'; }}</td>
                  <td class="">${x => new Date(x.created_at).toLocaleString()}</td>
                  <td>
                    ${(0, fast_element_1.when)(x => x.payload !== null, (0, fast_element_1.html) `
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-info"
                        @click="${(x, c) => c.parent.togglePayload(x.id)}"
                      >${(x, c) => c.parent.openPayloadId === x.id ? 'dblogs.hide'.t() : 'dblogs.show'.t()}</button>
                      ${(0, fast_element_1.when)((x, c) => c.parent.openPayloadId === x.id, (0, fast_element_1.html) `
                        <div class="mt-2">
                          <code-screen language="json" :passedContent="${(x, c) => c.parent.formatJson(x.payload)}"></code-screen>
                        </div>
                      `)}
                    `)}
                    ${(0, fast_element_1.when)(x => x.payload === null, (0, fast_element_1.html) `<span class="text-muted">—</span>`)}
                  </td>
                  <td>
                    ${(0, fast_element_1.when)(x => x.result !== null, (0, fast_element_1.html) `
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary"
                        @click="${(x, c) => c.parent.toggleResult(x.id)}"
                      >${(x, c) => c.parent.openResultId === x.id ? 'dblogs.hide'.t() : 'dblogs.show'.t()}</button>
                      ${(0, fast_element_1.when)((x, c) => c.parent.openResultId === x.id, (0, fast_element_1.html) `
                        <div class="mt-2">
                          <code-screen language="json" :passedContent="${(x, c) => c.parent.formatJson(x.result)}"></code-screen>
                        </div>
                      `)}
                    `)}
                    ${(0, fast_element_1.when)(x => x.result === null, (0, fast_element_1.html) `<span class="text-muted">—</span>`)}
                  </td>
                </tr>
              `)}
            </tbody>
          </table>
        </div>

        
        <app-pagination
          :currentPage="${x => x.currentPage}"
          :totalPages="${x => x.totalPages}"
          :totalItems="${x => x.count}"
          :perPage="${x => x.perPage}"
          @page-change="${(x, c) => x.goToPage(c.event.detail)}"
        ></app-pagination>
      </div>

    </div>
  </div>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `.dblogs-list-page {
  padding: 1.5rem 0;
}
.dblogs-list-page h1 {
  font-size: 1.6rem;
  margin: 0;
}

.dblogs-table {
  font-size: 0.875rem;
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: white;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 0;
}
.dblogs-table thead tr {
  background-color: #f8fafc;
}
.dblogs-table thead tr th {
  white-space: nowrap;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #475569;
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
}
.dblogs-table tbody tr {
  border-bottom: 1px solid #e2e8f0;
}
.dblogs-table tbody tr:last-child {
  border-bottom: none;
}
.dblogs-table tbody tr:hover {
  background-color: #f1f5f9;
}
.dblogs-table td {
  vertical-align: top;
  padding: 10px 16px;
  color: #334155;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dblogs-table .text-muted {
  color: #64748b !important;
}
.dblogs-table code-screen {
  display: block;
  max-width: 480px;
  max-height: 300px;
  overflow: auto;
  font-size: 0.78rem;
}

.dblogs-op-badge {
  font-size: 0.75rem;
  font-weight: 600;
  color: #FFF;
}
.dblogs-op-badge.dblogs-op-create {
  background-color: #198754;
}
.dblogs-op-badge.dblogs-op-createMany {
  background-color: #198754;
}
.dblogs-op-badge.dblogs-op-update {
  background-color: #0d6efd;
}
.dblogs-op-badge.dblogs-op-updateMany {
  background-color: #0d6efd;
}
.dblogs-op-badge.dblogs-op-upsert {
  background-color: #6f42c1;
}
.dblogs-op-badge.dblogs-op-delete {
  background-color: #dc3545;
}
.dblogs-op-badge.dblogs-op-deleteMany {
  background-color: #dc3545;
}

app-pagination {
  display: block;
  padding: 1rem 1.25rem;
  border-top: 1px solid #e2e8f0;
}`;
const shadowOptions = { "mode": "open" };
let DBLogsList = class DBLogsList extends client_1.RWSViewComponent {
    constructor(popupService) {
        super();
        this.popupService = popupService;
        this.loading = false;
        this.filtersLoading = true;
        this.logs = [];
        this.count = 0;
        this.totalPages = 1;
        this.currentPage = 1;
        this.perPage = 50;
        this.openPayloadId = null;
        this.openResultId = null;
        this.filters = {
            dateFrom: new Date().toISOString().slice(0, 10),
            dateTo: new Date().toISOString().slice(0, 10),
            models: [],
            operations: [],
            recordIds: [],
            page: 1,
            perPage: 50,
        };
        this.modelOptions = [];
        this.operationOptions = [];
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.loadFilters();
        await this.search();
    }
    async loadFilters() {
        try {
            const response = await this.apiService.back.get('dblogs.filters');
            if (response.success) {
                this.modelOptions = (response.models || []).map(m => ({
                    label: `model.${m}`.t(),
                    value: m,
                }));
                this.operationOptions = (response.operations || []).map(op => ({
                    label: `db.operation.${op}`.t(),
                    value: op,
                }));
            }
        }
        catch (e) {
            console.error('Failed to load filter options', e);
        }
        finally {
            this.filtersLoading = false;
        }
    }
    async search() {
        this.loading = true;
        this.currentPage = 1;
        this.filters = { ...this.filters, page: 1 };
        await this.fetchLogs();
    }
    async goToPage(page) {
        if (page < 1 || page > this.totalPages)
            return;
        this.currentPage = page;
        this.filters = { ...this.filters, page };
        await this.fetchLogs();
    }
    async fetchLogs() {
        var _a, _b, _c, _d;
        try {
            const payload = {
                page: this.currentPage, // 1-based
                perPage: this.perPage,
                language: (0, trans_1.getCurrentLanguage)()
            };
            if (this.filters.dateFrom)
                payload.dateFrom = this.filters.dateFrom;
            if (this.filters.dateTo)
                payload.dateTo = this.filters.dateTo;
            if (this.filters.models && this.filters.models.length > 0)
                payload.models = this.filters.models;
            if (this.filters.operations && this.filters.operations.length > 0)
                payload.operations = this.filters.operations;
            if (this.filters.recordIds && this.filters.recordIds.length > 0)
                payload.recordIds = this.filters.recordIds;
            const response = await this.apiService.back.post('dblogs.search', payload);
            if (response.success) {
                this.logs = (_a = response.data) !== null && _a !== void 0 ? _a : [];
                this.count = (_b = response.count) !== null && _b !== void 0 ? _b : 0;
                this.totalPages = (_c = response.totalPages) !== null && _c !== void 0 ? _c : 1;
            }
            else {
                this.popupService.alert((_d = response.error) !== null && _d !== void 0 ? _d : 'dblogs.error.fetch'.t());
            }
        }
        catch (e) {
            console.error(e);
            this.popupService.alert('dblogs.error.fetch'.t());
        }
        finally {
            this.loading = false;
        }
    }
    handleFilterChange(field, event) {
        var _a;
        const value = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.value;
        this.filters = { ...this.filters, [field]: value };
    }
    togglePayload(id) {
        this.openPayloadId = this.openPayloadId === id ? null : id;
        this.openResultId = null;
    }
    toggleResult(id) {
        this.openResultId = this.openResultId === id ? null : id;
        this.openPayloadId = null;
    }
    formatJson(data) {
        if (!data)
            return 'null';
        return JSON.stringify(data, null, 2);
    }
};
exports.DBLogsList = DBLogsList;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], DBLogsList.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], DBLogsList.prototype, "filtersLoading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], DBLogsList.prototype, "logs", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], DBLogsList.prototype, "count", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], DBLogsList.prototype, "totalPages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], DBLogsList.prototype, "currentPage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], DBLogsList.prototype, "openPayloadId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], DBLogsList.prototype, "openResultId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof backendImport_1.IDBLogFilters !== "undefined" && backendImport_1.IDBLogFilters) === "function" ? _b : Object)
], DBLogsList.prototype, "filters", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof Array !== "undefined" && Array) === "function" ? _c : Object)
], DBLogsList.prototype, "modelOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof Array !== "undefined" && Array) === "function" ? _d : Object)
], DBLogsList.prototype, "operationOptions", void 0);
exports.DBLogsList = DBLogsList = __decorate([
    (0, client_1.RWSView)('dblogs-list', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object])
], DBLogsList);
DBLogsList.defineComponent();
